import ClearIcon from "@mui/icons-material/Clear";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import { IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import AttachmentLightbox from "components/Attachments/AttachmentLightbox";
import CopyAttachmentButton from "components/Attachments/CopyAttachmentButton";
import { getOriginalFileName } from "utils/utils";

/** Inline thumbnail of an image attachment; clicking it opens the large preview. */
const ImageAttachmentTile = ({ url, onRemove, onError }) => {
  const [loaded, setLoaded] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const name = getOriginalFileName(url) || "Image";

  const handleLightboxError = () => {
    setPreviewOpen(false);
    onError?.();
  };

  return (
    <div className="group relative h-24 w-24 flex-shrink-0 overflow-hidden rounded-lg border border-app-border bg-app-surface-muted">
      <button
        type="button"
        onClick={() => setPreviewOpen(true)}
        title={name}
        aria-label={`Preview ${name}`}
        className="relative block h-full w-full cursor-zoom-in border-0 bg-transparent p-0"
      >
        {!loaded && <span className="absolute inset-0 animate-pulse bg-app-surface-hover" />}
        <img
          src={url}
          alt={name}
          loading="lazy"
          onLoad={() => setLoaded(true)}
          onError={onError}
          className="h-full w-full object-cover"
        />
        <span className="absolute bottom-1 left-1 flex h-5 w-5 items-center justify-center rounded bg-black/55 text-white opacity-0 transition-opacity group-hover:opacity-100">
          <ZoomInIcon sx={{ fontSize: 14 }} />
        </span>
      </button>
      <div className="absolute right-1 top-1 flex items-center rounded-md bg-app-surface shadow-sm">
        <CopyAttachmentButton url={url} iconSize={13} />
        {onRemove && (
          <Tooltip title="Remove attachment">
            <IconButton size="small" onClick={onRemove} aria-label="Remove attachment">
              <ClearIcon sx={{ fontSize: 13 }} />
            </IconButton>
          </Tooltip>
        )}
      </div>
      {previewOpen && (
        <AttachmentLightbox
          url={url}
          open={previewOpen}
          onClose={() => setPreviewOpen(false)}
          onError={handleLightboxError}
        />
      )}
    </div>
  );
};

export default ImageAttachmentTile;
